import type { ComponentConfig } from '@puckeditor/core';
import { MobileStickyCall } from './mobile-sticky-call';
import { MobileStickyCallFields } from "./mobile-sticky-call.fields";
import type { MobileStickyCallProps } from './mobile-sticky-call';

/**
 * Puck component configuration for Mobile Sticky Call Button
 *
 * This component should be added once per page, typically alongside the Hero.
 * It auto-populates the phone number from business context.
 */
const MobileStickyCallConfig: ComponentConfig<MobileStickyCallProps> = {
  defaultProps: {
    buttonText: "Call Now",
    dismissible: true,
    phone: "", // Auto-populated from business context
    scrollThreshold: 400,
  },
  fields: {
    phone: MobileStickyCallFields.phone,
    buttonText: { ...MobileStickyCallFields.buttonText, contentEditable: true },
    scrollThreshold: MobileStickyCallFields.scrollThreshold,
    dismissible: MobileStickyCallFields.dismissible,
  },
  label: "Mobile Sticky Call Button",
  render: ({ puck, ...props }) => {
    // Access business data from Puck metadata OR window config (fallback)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const puckMetadata = puck?.metadata as any,
      windowConfig =
        typeof window !== "undefined"
          ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any).__SERVICEPRO_CONFIG__
          : {},
      business = puckMetadata?.business || windowConfig?.business,

      // Get phone number from business context if not provided
      phone = props.phone || business?.phone || business?.telephone || "";

    // Don't render if no phone available
    if (!phone) {
      return <></>;
    }

    return <MobileStickyCall {...props} phone={phone} />;
  },
};

export { MobileStickyCallConfig };
